import {baseURL, getJSON, postData} from "./API"
import axios from "axios";
import { getRequest, postRequest} from "./AxiosConfig";

const apiMapping = "api/course";

export async function getLabCourseChapter(experiment) {
    return await getRequest(`/lab/${experiment}`);
}

export async function getModuleContentByName(courseName, moduleName, chapterName, setErrorMessage) {
    return await getRequest(`/course/content/${courseName}/${moduleName}/${chapterName}`, setErrorMessage);
}

export async function getModuleContentPreview(courseName, moduleName, chapterName, setErrorMessage) {
    if(moduleName == null || chapterName == null) {
        return await getRequest(`/course/content/public/${courseName}`, setErrorMessage)
    }

    return await getRequest(`/course/content/public/${courseName}/${moduleName}/${chapterName}`, setErrorMessage)
}

export async function getCourseResponse(request, chapterId, productId) {
    const response = await postData(apiMapping+"/ai/question", {request:request, chapterId:chapterId, productId:productId});
    return await response.json()

}

export async function getPerformanceStats(){
    return await getRequest("/product/performance");
}

export async function getPeriodicElements() {
    return await getJSON(apiMapping+"/interactive/periodic");
}


export async function createTask(chapter, contents) {
    return await postData(apiMapping+"/create_task", {
        chapterId:chapter,
        markdown:contents
    });
}

export async function renderCourse(contents) {
    return await axios.post(baseURL+apiMapping+"/validate", {
        markdown:contents
    }, {
        withCredentials: "true",
        headers: {
            'Content-Type': 'application/json',
        },
    } );
}

export async function createAIMessage(message, setErrorMessage){
    return await postRequest( "/ai/message", setErrorMessage, {
        tekst:message.content,
        type: message.contentType,
        fag: "Kjemi 1"
    });
}

export async function getCourseChapters(courseId, setErrorMessage) {
    return await getRequest( "/course/content/chapters/"+courseId, setErrorMessage);
}

export async function getModuleInfo(courseId, moduleName, setErrorMessage) {
    return await getRequest( `/course/module/info/${courseId}/${moduleName}`, setErrorMessage);
}

export async function getLabCourseExperiments(courseId, setErrorMessage) {
    return await getRequest( "/lab/chapters/"+courseId, setErrorMessage);
}

export async function getMediaFile(url, setErrorMessage) {
    return await getRequest(url, setErrorMessage, false);
}

export async function testStream(setErrorMessage){
    return await postRequest( "/ai/stream", setErrorMessage, {});
}

export async function getTask(id, setErrorMessage) {
    return await getRequest(`/course/task/${id}`, setErrorMessage);
}

export async function getCourseNavigation(id, setErrorMessage) {
    return await getRequest(`/course/content/chapters/${id}`, setErrorMessage);
}

export async function getCourseNavigationPreview(id, setErrorMessage) {
    return await getRequest(`/course/content/public/chapters/${id}`, setErrorMessage);
}


